<template>
  <a-modal
    :title="orderType==='RECHARGE'?'充值':'续费'"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :ok-text="orderType==='RECHARGE'?'确认充值':'确认续费'"
    :width="600"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div v-if="orderType==='RECHARGE'">充值方案：
      <div class="cus-radio-group">
        <div
          class="cus-radio"
          :class="{'active': index === activeIndex}"
          v-for="(item, index) in dict.rechargePriceDict"
          :key="index"
          @click="activeIndex=index"
        >
          ￥{{ item.price }} <br />
          {{ item.count }}张
        </div>
      </div>
    </div>
    <div v-if="orderType==='ANNUAL'">续费方案：
      <div class="cus-radio-group">
        <div
          class="cus-radio"
          :class="{'active': index === activeIndex}"
          v-for="(item, index) in dict.annualPriceDict"
          :key="index"
          @click="activeIndex=index"
        >
          ￥{{ item.value }} <br />
          {{ item.id === 'NORMAL'? '买码会员1年' : '无限码会员1年' }}
        </div>
      </div>
    </div>
    <p class="mt-20">支付方式：
      <a-radio-group v-model="payType">
        <a-radio
          v-for="item in dict.payTypeDict"
          :key="item.id"
          :value="item.id"
        >
          <a-icon v-if="item.id === 'WEIXIN'" type="wechat" />
          <a-icon v-if="item.id === 'ALIPAY'" type="alipay-circle" />
          {{ item.name }}
        </a-radio>
      </a-radio-group>
    </p>
  </a-modal>
</template>

<script>
import { getOrderPre, postRechargeOrderAdd, postAnnualOrderAdd } from '@/api/print'

export default {
  data() {
    return {
      orderType: 'RECHARGE', // 订单类型（RECHARGE-充值订单；ANNUAL-续费订单）
      visible: false,
      confirmLoading: false,
      dict: {
        payTypeDict: [],
        rechargePriceDict: [],
        annualPriceDict: []
      },
      payType: 'WEIXIN',
      activeIndex: 0
    }
  },
  props: {},
  watch: {},
  methods: {
    // 预加载
    getPre() {
      getOrderPre()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.dict.payTypeDict = data.payTypeDict
            this.dict.rechargePriceDict = data.rechargePriceDict
            this.dict.annualPriceDict = data.annualPriceDict
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载失败')
        })
    },
    showModal(orderType, orderId) {
      this.orderType = orderType // 订单类型（RECHARGE-充值订单；ANNUAL-续费订单）
      this.activeIndex = 0
      this.visible = true
      this.getPre()
    },
    handleOk() {
      if (this.orderType === 'RECHARGE') {
        // 创建充值订单
        this.postRechargeOrderAdd()
      }
      if (this.orderType === 'ANNUAL') {
        // 创建年费订单
        this.postAnnualOrderAdd()
      }
    },
    handleCancel() {
      this.visible = false
      this.$emit('cancel')
    },
    // 创建充值订单
    postRechargeOrderAdd() {
      this.confirmLoading = true
      const price = this.dict.rechargePriceDict[this.activeIndex].price
      const count = this.dict.rechargePriceDict[this.activeIndex].count
      postRechargeOrderAdd({
        count: count,
        price: price,
        pay_type: this.payType
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.visible = false
            this.$emit('ok', {
              pay_type: this.payType,
              total_price: price,
              order_type: this.orderType,
              orderId: data.orderId
            })
          }
        })
        .catch((e) => {
          this.$message.error('请求创建充值订单失败')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    // 创建年费订单
    postAnnualOrderAdd() {
      this.confirmLoading = true
      const type = this.dict.annualPriceDict[this.activeIndex].id
      const price = this.dict.annualPriceDict[this.activeIndex].value
      postAnnualOrderAdd({
        type: type,
        pay_type: this.payType
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.visible = false
            this.$emit('ok', {
              pay_type: this.payType,
              total_price: price,
              order_type: this.orderType,
              orderId: data.orderId
            })
          }
        })
        .catch((e) => {
          this.$message.error('请求创建年费订单失败')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    }
  }
}
</script>
<style lang="less" scoped>
.qrcode {
  width: 200px;
  height: 200px;
  background-color: #eee;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .loading {
    position: absolute;
    top: 0;
    left: 0;
  }
  .fresh-qrcode-btn {
    position: absolute;
    right: -50px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.money {
  text-align: center;
  font-size: 18px;
  margin: 10px 0;
}
.red {
  color: red;
}
.fw-b {
  font-weight: bolder;
}
.cus-radio-group {
  display: flex;
  flex-wrap: wrap;
  .cus-radio {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 10px 0;
    border: 1px solid #eee;
    margin: 10px;
    min-width: 150px;
    &.active {
      border: 1px solid yellow;
      background: rgba(110, 110, 110, 0.5);
      box-shadow: 0 0 4px 2px #f7ff2cb8;
    }
  }
}
</style>
